import { render, staticRenderFns } from "./ed-treeview-container.vue?vue&type=template&id=af56b3bc&scoped=true&"
import script from "./ed-treeview-container.ts?vue&type=script&lang=ts&"
export * from "./ed-treeview-container.ts?vue&type=script&lang=ts&"
import style0 from "./ed-treeview-container.scss?vue&type=style&index=0&id=af56b3bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af56b3bc",
  null
  
)

export default component.exports